const state = {
  showMenu: null,
  showMenuRight: null
};

const mutations = {
  TOGGLE_MENU(state, open) {
    state.showMenu = open;
  },
  TOGGLE_MENU_RIGHT(state, open) {
    state.showMenuRight = open;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
